import {makeAutoObservable} from 'mobx';
import {User, UserRole} from 'models/User';
import {Platform} from 'react-native';
import UsersApiManager from 'services/API/UsersApi/UsersApiManager';
import LocalStorage, {LocalStorageType} from 'services/LocalStorage';
import strings from 'translations';
import {PopUpStore} from './PopUpStore';
import {LoaderStore} from './LoaderStore';

export class UserStore {
  private usersApiManager = new UsersApiManager();
  private popUpStore: PopUpStore;
  private loaderStore: LoaderStore;

  user: User | null = null;

  constructor(popUpStore: PopUpStore, loaderStore: LoaderStore) {
    this.popUpStore = popUpStore;
    this.loaderStore = loaderStore;
    makeAutoObservable(this);
  }

  get fullUserName() {
    return `${this.user?.name ?? ''} ${this.user?.surname ?? ''}`;
  }

  setUser = (user: User | null) => {
    this.user = user;
  };

  getCurrentUserIfNeeded = async () => {
    if (!!this.user) {
      return;
    }

    try {
      const user = await this.usersApiManager.getCurrentUser();
      this.setUser(user as User);
      console.log('user', user);
    } catch (err) {
      LocalStorage.delete(LocalStorageType.accessToken);
      LocalStorage.delete(LocalStorageType.refreshToken);
      this.popUpStore.setError(strings.errors.userNotFoundInTheSystem);
      throw err;
    }
  };

  deleteUser = async () => {
    try {
      this.user?.id && (await this.usersApiManager.deleteUser(this.user?.id));
      this.setUser(null);
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  setImage = (image: string) => {
    if (this.user) {
      this.user.image = image;
    }
  };

  changePhoto = async (image?: File, imageUri?: string) => {
    this.setImage(imageUri ?? '');
    try {
      Platform.OS === 'web'
        ? await this.usersApiManager.changePhotoWeb(image)
        : await this.usersApiManager.changePhoto(imageUri);
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  deletePhoto = async () => {
    try {
      this.loaderStore.startLoading();
      await this.usersApiManager.deletePhoto();
      this.setImage('');
      this.loaderStore.stopLoading();
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  logOut = () => {
    LocalStorage.delete(LocalStorageType.refreshToken);
    LocalStorage.delete(LocalStorageType.accessToken);
    this.setUser(null);
  };

  get isTeacherOrAdmin() {
    return (
      this.user?.role == UserRole.teacher || this.user?.role == UserRole.admin
    );
  }

  get isAdmin() {
    return this.user?.role == UserRole.admin;
  }
}
